import React, { useState } from "react";
import TextEditor from "./TextEditor";
import "./addnewproduct.scss";
import { useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import axios from "axios";
import CreateMintCategory from "hooks/dataSenders/createMintCategory";
import { toast } from "react-toastify";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "hooks/useWeb3";
import Loader from "hooks/loader";
import { useHistory } from "react-router";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { API_URL } from "utils/ApiUrl";

const extractMediaUrlFromResponse = (payload) => {
  return (
    payload?.url ||
    payload?.data?.url ||
    payload?.data?.data?.url ||
    payload?.location ||
    payload?.data?.location ||
    payload?.secure_url ||
    payload?.data?.secure_url ||
    null
  );
};

const toSerializableValue = (value) => {
  if (typeof value === "bigint") return value.toString();
  if (value && typeof value?.toString === "function") {
    try {
      const str = value.toString();
      // Preserve primitive-like values while avoiding "[object Object]"
      if (str !== "[object Object]") return str;
    } catch (e) {
      // no-op
    }
  }
  return value;
};

const Addnewproduct = () => {
  const [text, setText] = useState("");
  const [text1, setText1] = useState("");
  console.log("asdfasdfads", text);

  const history = useHistory();

  const fileInputRef = useRef(null);
  const fileInputRef1 = useRef(null);
  const [selectedFile, setSelectedFile] = useState();
  const [imageData, setImageData] = useState([]);
  const [collectionName, setcollectionName] = useState("testCollection");

  const [inputs, setInputs] = useState({
    title: "",
    supply: "",
    // description: "",
    cost: "",
    propertyPrice: "",
    maxMintAmount: "",
    metadata: "",
    location: "",
    area: "",
    bedrooms: "",
    bathrooms: "",
    annualRentalIncome: "",
    overviewText: "",
    generalInfo: "",
    // add more fields as
    file: null,
    file1: [],
  });
  const [show, setShow] = useState(false);

  console.log("inputsss", inputs);
  const setEditor = (data) => {
    console.log("we get here is ", data);
    setInputs({ ...inputs, description: data, length: data.length - 8 });
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [thumbnailImg, setThumbnailImg] = useState(null);
  const [galleryIMG, setGalleryIMG] = useState(null);

  console.log(galleryIMG, thumbnailImg, "imagesssssss");

  // const handleFileUpload = (event, type) => {
  //   const file = event.target.files[0];

  //   console.log(file, "fileeeeee......");

  //   const selectedFiles = Array.from(event.target.files);

  //   if (selectedFiles.length === 0) return; // If no files are selected, exit the function.

  //   setSelectedFile((prevFiles) => [
  //     ...(Array.isArray(prevFiles) ? prevFiles : []),
  //     ...selectedFiles,
  //   ]);

  //   if (file) {
  //     if (type === 'thumbnail') {
  //       const imageUrl1 = URL?.createObjectURL(file);
  //       console.log(file, "fileeeeee...... 1111");
  //       setThumbnailImg(imageUrl1);

  //       setInputs({ ...inputs, file }); // Set thumbnail image
  //     } else if (type === 'gallery') {
  //       // setSelectedFile(file);
  //       setImageData({ ...inputs });
  //       const imageUrl2 = URL?.createObjectURL(file);
  //       console.log(file, "fileeeeee...... 2222");
  //       const imageUrl3 = URL?.createObjectURL(file);
  //       setGalleryIMG(imageUrl2)

  //       setInputs({ ...inputs, file1: file }); // Set gallery image
  //     }
  //   }
  // };

  const [galleryimages, setGalleryImages] = useState([]);

  const handleFileUpload = (event, type) => {
    const files = event.target.files;
    console.log(files, "fileseeeee......");
    const selectedFiles = Array.from(event.target.files);

    if (files.length === 0) return; // Agar koi file select nahi hui toh function exit karein.
    if (type === "thumbnail") {
      const file = files[0]; // Thumbnail ke liye sirf ek file
      const imageUrl = URL?.createObjectURL(file);
      setThumbnailImg(imageUrl);
      setInputs((prevInputs) => ({ ...prevInputs, file })); // Thumbnail set karein

      if (selectedFiles.length === 0) return; // If no files are selected, exit the function.

      setSelectedFile((prevFiles) => [
        ...(Array.isArray(prevFiles) ? prevFiles : []),
        ...selectedFiles,
      ]);
    } else if (type === "gallery") {
      const selectedFiles = Array.from(files); // Gallery ke liye multiple files
      const galleryUrls = selectedFiles.map((file) =>
        URL?.createObjectURL(file)
      );
      setGalleryImages((prevGallery) => [...prevGallery, ...galleryUrls]); // Add new images to state
      setInputs((prevInputs) => ({
        ...prevInputs,
        file1: [...prevInputs.file1, ...selectedFiles], // Add new files to inputs
      }));
      setImageData({ ...inputs });
    }
  };

  // console.log(galleryimages, "galleryimagesgalleryimagesgalleryimages");

  // const handleGalleryImages = (event) => {
  //   const files = event.target.files;
  //   console.log(files, "fileseeeee......");

  //   const selectedFiles = Array.from(files); // Gallery ke liye multiple files
  //   const galleryUrls = selectedFiles.map((file) => URL?.createObjectURL(file));
  //   setGalleryImages((prevGallery) => [...prevGallery, ...galleryUrls]); // Add new images to state
  // };

  //api

  //  ========================================================= IPFS ======================================================= //

  let token =
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySW5mb3JtYXRpb24iOnsiaWQiOiJkY2M5MGVjNC04NWYwLTRjZjktODg3ZS03NmM5MzJiMjMzYjkiLCJlbWFpbCI6InVzbWFuLm1hbGlrbnUxM0BnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwicGluX3BvbGljeSI6eyJyZWdpb25zIjpbeyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJGUkExIn0seyJkZXNpcmVkUmVwbGljYXRpb25Db3VudCI6MSwiaWQiOiJOWUMxIn1dLCJ2ZXJzaW9uIjoxfSwibWZhX2VuYWJsZWQiOmZhbHNlLCJzdGF0dXMiOiJBQ1RJVkUifSwiYXV0aGVudGljYXRpb25UeXBlIjoic2NvcGVkS2V5Iiwic2NvcGVkS2V5S2V5IjoiMmJiZDFkZmM3YWI2ZDg0MzEwY2UiLCJzY29wZWRLZXlTZWNyZXQiOiI3ODNhMmMyOGY5Yzc4OGRmNGE3ZDQ4YjU2N2NjNzUwYjRkMWZjMDM0OWI0MGFjYzYwZjhjOTQ1ZmM4ZmI3MDE4IiwiZXhwIjoxNzYyODY5Mzk4fQ.hIRx3GiuH5vbStB6kuLL4Z9tiDRTyuRmPi4SPTOOi5I";
  const apikey = "2bbd1dfc7ab6d84310ce";
  const secretapikey =
    "783a2c28f9c788df4a7d48b567cc750b4d1fc0349b40acc60f8c945fc8fb7018";

  let { account } = useWeb3React();
  const web3 = useWeb3();

  const [isSubmitted, setIsSubmitted] = useState(false);
  console.log(selectedFile, "selectedFiles in logggggg");

  // const [id, setId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState("");
  const [metaHash, setMetaHash] = useState("");

  const [existingHashes, setexistingHashes] = useState(null);

  const selectMultipulImages = (e) => {
    const selectedFiles = Array.from(e.target.files);
    console.log(selectedFiles, "selectedFiles in fun");

    setSelectedFile(selectedFiles);
  };

  const handleImageChange = async () => {
    // debugger
    console.log("Starting image upload process", selectedFile);

    if (!selectedFile || selectedFile.length === 0) {
      toast.error("No images selected.");
      return;
    }

    setLoader(true);

    setLoaderMessage(
      <span style={{ color: "white" }}>Uploading images to IPFS...</span>
    );

    const existingHashes111 = [];

    // const existingHashes = JSON.parse(localStorage.getItem("fileHashes") || "[]");
    console.log("here are we", selectedFile);

    try {
      if (selectedFile) {
        for (let i = 0; i < selectedFile?.length; i++) {
          console.log(`Uploading image ${i + 1} of ${selectedFile.length}`);

          const formData = new FormData();
          formData.append("file", selectedFile[i]); // Append only the current file
          const options = { pinataOptions: { cidVersion: 0 } };
          formData.append("pinataOptions", JSON.stringify(options));
          console.log("here are we 2");
          const response = await fetch(
            "https://api.pinata.cloud/pinning/pinFileToIPFS",
            {
              method: "POST",
              headers: {
                Authorization: `Bearer ${token}`,
              },
              body: formData,
            }
          );

          if (!response.ok) {
            throw new Error(`Failed to upload image ${i + 1}`);
          }

          const { IpfsHash } = await response.json();
          if (IpfsHash) {
            existingHashes111.push(IpfsHash);
            console.log(`Image ${i + 1} uploaded successfully: ${IpfsHash}`);
          } else {
            throw new Error(`Failed to get IPFS hash for image ${i + 1}`);
          }
        }
        // localStorage.setItem("fileHashesmm", 'hello  111');
        console.log("========>", existingHashes111);

        if (existingHashes111?.length > 0) {
          setexistingHashes(existingHashes111);
          localStorage.setItem("fileHashes", JSON.stringify(existingHashes111));
        }

        if (existingHashes111?.length > 0) {
          toast.success("All images uploaded successfully!");
          console.log("All IPFS hashes:", existingHashes111);
        }

        console.log(
          existingHashes111,
          "existingHashesexistingHashesexistingHashesexistingHashes"
        );

        return existingHashes111;
      }
    } catch (error) {
      setLoader(false);
      console.error("Error uploading images:", error);
      toast.error(`Failed to upload images: ${error.message}`);
    }
  };

  async function upload() {
    const ipfsImgres = await handleImageChange();
    console.log(ipfsImgres, "ipfsImgres");

    const existingHashes = JSON.parse(localStorage.getItem("fileHashes"));
    const uploadedMetadataUrls = [];
    const metadataHashes = []; // Initialize an array to store metadata hashes

    try {
      setLoader(true);
      // Prepare FormData with the JSON file
      const formDataMetadata = new FormData();
      // formDataMetadata.append("file", metadataFile, `${collectionName}/${i}`);

      console.log("here 0");
      // for (let i = 0; i < imageData.length; i++) {
      // const image = inputs;
      // const ipfsImageUrl = `https://ipfs.io/ipfs/${existingHashes[i]}/`;
      const ipfsImageUrl = `ipfs://${existingHashes[0]}`;
      console.log(
        "here 1",
        "ipfsImageUrl 0",
        ipfsImageUrl[0],
        "ipfsImageUrl 1",
        ipfsImageUrl[1]
      );
      // Create metadata object
      const metadata1 = {
        name: inputs.title,
        description: inputs.generalInfo,
        image: ipfsImageUrl,
        price: inputs.propertyPrice,
        id: 1,
      };
      console.log("here 2");

      console.log(
        metadata1,
        "metadata1metadata1metadata1metadata1metadata1metadata1"
      );

      // Convert metadata object to JSON and then to Blob
      const metadataJson = JSON.stringify(metadata1);
      const metadataBlob = new Blob([metadataJson], { type: "text/plain" });
      const metadataFile = new File([metadataBlob], `metadata-${1}.json`, {
        type: "text/plain",
      });
      console.log("here 3");

      formDataMetadata.append("file", metadataFile, `${collectionName}/${1}`);

      const metadata = JSON.stringify({
        name: collectionName,
      });
      console.log("here 6");

      formDataMetadata.append("pinataMetadata", metadata);

      const options = JSON.stringify({
        cidVersion: 0,
      });
      formDataMetadata.append("pinataOptions", options);

      // Upload the metadata file to Pinata
      const metadataUploadResponse = await axios.post(
        "https://api.pinata.cloud/pinning/pinFileToIPFS/",
        formDataMetadata,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
            pinata_api_key: `${apikey}`,
            pinata_secret_api_key: `${secretapikey}`,
          },
        }
      );

      // Extract the IPFS hash for the metadata and form the URL
      const metadataIpfsHash = metadataUploadResponse.data.IpfsHash;
      const metadataIpfsUrl = `https://gateway.pinata.cloud/ipfs/${metadataIpfsHash}/`;

      console.log(
        metadataUploadResponse,
        "metadataUploadResponse okokokokok.........."
      );

      uploadedMetadataUrls.push(metadataIpfsUrl);

      if (metadataIpfsHash) {
        metadataHashes.push(metadataIpfsHash); // Add hash to array
      } else {
        toast.error("Failed to obtain IPFS hash for an image.");
      }

      localStorage.setItem("metadataHashes", JSON.stringify(metadataHashes));
      setMetaHash(JSON.stringify(metadataHashes));
      // localStorage.removeItem("fileHashes");  // Optionally, clear the image hashes

      const imgHashes = localStorage?.getItem("fileHashes");
      console.log(
        imgHashes,
        "fileHashes fileHashesfileHashesfileHashesfileHashesfileHashes"
      );

      // All metadata has been uploaded successfully
      console.log("All metadata uploaded successfully:", uploadedMetadataUrls);
      // setLoader(false);
      setLoaderMessage("");

      // settoggle(!toggle);
      return metadataHashes;
    } catch (error) {
      console.error("Error during metadata upload:", error);
      toast.error("Error during metadata upload");
      setLoader(false);
      setLoaderMessage("");
      return null;
    }
  }

  // const handleUploadMetadata = async () => {
  //   return upload();
  // };

  //  ========================================================= IPFS ======================================================= //

  const { CreateMintCategoryHook } = CreateMintCategory();

  // _name, _maxMintAmount, _maxSupply, _costPerNft, _uri, _rentAmount

  console.log(
    inputs?.maxMintAmount,
    inputs?.supply,
    "typeeeeeeeeeeeeeeeeeeeeeee"
  );

  const createMintCategory = async () => {
    console.log(inputs, "inputsinputsinputsinputsinputsinputsinputsinputs");

    if (account) {
      if (
        imageData &&
        selectedFile &&
        inputs?.title &&
        inputs?.supply &&
        inputs?.cost &&
        inputs?.maxMintAmount
      ) {
        // // Check if supply is greater than maxMintAmount
        // if (inputs.supply <= inputs.maxMintAmount) {
        //   toast?.error("Mint amount user must be less then supply");
        //   return;        //
        // Check if supply is greater than maxMintAmount
        if (
          inputs.supply != null &&
          inputs.maxMintAmount != null &&
          Number(inputs.supply) <= Number(inputs.maxMintAmount)
        ) {
          toast?.error("Mint amount user must be less than supply");
          return;
        }

        setLoader(true);
        const resNFT = await upload();
        console.log(resNFT, "resNFT");

        // if(inputs.maxMintAmount > inputs?.supply)

        if (resNFT) {
          const metadataCid = Array.isArray(resNFT) ? resNFT[0] : resNFT;
          const contractTokenUri = `ipfs://${metadataCid}/1`;
          const apiTokenUri = `ipfs://${metadataCid}/`;
          const nftCostInWei = web3.utils.toWei(
            inputs?.cost?.toString(),
            "ether"
          );
          console.log(
            "payload in comp",
            inputs?.title,
            inputs?.maxMintAmount,
            inputs?.supply,
            inputs?.propertyPrice,
            nftCostInWei,
            contractTokenUri,
            inputs?.annualRentalIncome
          );

          try {
            setLoader(true);
            // setLoaderMessage("Creating your category on contract");
            setLoaderMessage(
              <span style={{ color: "white" }}>
                Creating your category on contract
              </span>
            );

            const ress = await CreateMintCategoryHook(
              inputs?.title,
              inputs?.maxMintAmount,
              inputs?.supply,
              nftCostInWei,
              contractTokenUri,
              inputs?.annualRentalIncome
            );
            console.log(
              ress,
              "res in createMintCategory",
              ress?.events?.CreateMintCategory?.returnValues?.categoryIndex
            );

            if (ress) {
              setLoader(true);
              setLoaderMessage("Sending data to API...");
              const apiRes = await handleSubmit(
                ress?.events?.CreateMintCategory?.returnValues?.categoryIndex,
                ress?.transactionHash,
                ress?.blockNumber,
                apiTokenUri
              );
              console.log(apiRes, "apiRes apiRes apiRes");
              setInputs("");
              setLoader(false);
            }
            setLoader(false);
          } catch (error) {
            setLoader(false);
            toast?.error(error?.message);
            console.log(
              error,
              "error in createMintCategory",
              "error?.message",
              error?.message
            );
          }
        }
        setLoader(false);
      } else {
        toast?.error("All fields are required");
      }
    } else {
      toast?.error("Connect your wallet");
    }
  };

  const handleSubmit = async (
    categoryIndex,
    transactionHash,
    blockNumber,
    tokenURI
  ) => {
    const token = localStorage.getItem("token"); // Retrieve the token

    console.log(token); // Fixed typo here
    try {
      const thumbnailImageUrl = tokenURI;

      const galleryFiles = Array.isArray(inputs?.file1)
        ? inputs.file1
        : inputs?.file1
        ? [inputs.file1]
        : [];

      let galleryImageUrls = [];
      if (galleryFiles.length > 0) {

        setLoaderMessage("Uploading gallery images to media API...");
        galleryImageUrls = [];

        for (const file of galleryFiles) {
          const mediaFormData = new FormData();
          mediaFormData.append("media", file);

          const mediaResponse = await axios.post(
            `${API_URL}/medias/upload`,
            mediaFormData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
              },
            }
          );

          const mediaUrl = extractMediaUrlFromResponse(mediaResponse?.data);
          if (!mediaUrl) {
            throw new Error(
              "Media API did not return a valid file URL for gallery image."
            );
          }
          galleryImageUrls.push(mediaUrl);
        }
      }

      // Send simple JSON payload to projects API.
      const payload = {
        name: inputs.title,
        supply: inputs.supply,
        costPerNft: inputs.cost,
        propertyPrice: inputs.propertyPrice,
        location: inputs.location,
        area: inputs.area,
        bedrooms: inputs.bedrooms,
        bathrooms: inputs.bathrooms,
        annualRentalIncome: inputs.annualRentalIncome,
        overviewText: text,
        generalInfo: text1,
        categoryIndex: toSerializableValue(categoryIndex),
        blockNumber: toSerializableValue(blockNumber),
        transactionHash: toSerializableValue(transactionHash),
        uri: tokenURI,
        thumbnailImage: thumbnailImageUrl,
        galleryImages: galleryImageUrls,
      };

      console.log(payload, "payload payload payload payload payload");

      const response = await axios.post(
        `${API_URL}/projects`,
        // "http://ec2-18-236-225-148.us-west-2.compute.amazonaws.com:8088/projects",
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`, // Add token to headers
          },
        }
      );

      console.log(response.data, "Api response");

      localStorage?.removeItem("metadataHashes");
      localStorage?.removeItem("fileHashes");

      history?.push("/admin/badgesandpoints");
    } catch (error) {
      console.error("Error during API call", error);
    }
  };

  /// img

  return (
    <>
      {loader && <Loader text={loaderMessage} />}
      <div className="content">
        <section className="addnewproduct">
          <div className="mainleftright">
            <div className="leftside">
              <div className="rightside">
                <div className="innerrighrtside">
                  <div className="updodngouterdiv">
                    <div className="outtter_upload">
                      <h3>Thumbnail Image</h3>
                      <div className="uplood__div">
                        <div className="dashedborderdiv">
                          <div
                            className="uploadbody"
                            style={{ position: "relative" }}
                            onClick={() => fileInputRef1.current.click()}
                          >
                            <input
                              type="file"
                              ref={fileInputRef1}
                              style={{ display: "none" }}
                              onChange={(e) => handleFileUpload(e, "thumbnail")}
                              // onChange={(e) => hanldeImg(e)}
                            />
                            {thumbnailImg ? (
                              <>
                                {/* <label htmlFor="asdfasf">
                                  </label> */}
                                <img
                                  src={thumbnailImg}
                                  onClick={(e) =>
                                    handleFileUpload(e, "thumbnail")
                                  }
                                />
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setThumbnailImg(null);
                                  }}
                                  style={{
                                    position: "absolute",
                                    top: "5px",
                                    right: "5px",
                                    backgroundColor: "rgba(255, 0, 0, 0.8)",
                                    color: "white",
                                    border: "none",
                                    borderRadius: "50%",
                                    width: "18px",
                                    height: "18px",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    lineHeight: "1",
                                  }}
                                >
                                  &times; {/* HTML entity for a close icon */}
                                </button>

                                {/* <input
                                    type="asdfasf"
                                    ref={fileInputRef1}
                                    style={{ display: "none" }}
                                    onChange={(e) =>
                                      handleFileUpload(e, "thumbnail")
                                    }
                                    // onChange={(e) => hanldeImg(e)}
                                  /> */}
                              </>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="29"
                                height="28"
                                viewBox="0 0 29 28"
                                fill="none"
                              >
                                <path
                                  d="M11 11.6667C12.2887 11.6667 13.3333 10.622 13.3333 9.33333C13.3333 8.04467 12.2887 7 11 7C9.71133 7 8.66666 8.04467 8.66666 9.33333C8.66666 10.622 9.71133 11.6667 11 11.6667Z"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M15.6667 2.3335H11C5.16668 2.3335 2.83334 4.66683 2.83334 10.5002V17.5002C2.83334 23.3335 5.16668 25.6668 11 25.6668H18C23.8333 25.6668 26.1667 23.3335 26.1667 17.5002V11.6668"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M21.5 2.3335V9.3335L23.8333 7.00016"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M21.5 9.33333L19.1667 7"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M3.61499 22.1083L9.36666 18.2467C10.2883 17.6283 11.6183 17.6983 12.4467 18.41L12.8317 18.7483C13.7417 19.53 15.2117 19.53 16.1217 18.7483L20.975 14.5833C21.885 13.8017 23.355 13.8017 24.265 14.5833L26.1667 16.2167"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            )}
                            <div>
                              <h2>Click to upload</h2>
                              {/* <p>or drag and drop</p> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="outtter_upload">
                      <h3>Gallery Image</h3>
                      <div className="uplood__div">
                        <div className="dashedborderdiv">
                          <div
                            className="uploadbody"
                            onClick={() => fileInputRef.current.click()}
                          >
                            <>
                              <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: "none" }}
                                onChange={(e) => handleFileUpload(e, "gallery")}
                                multiple
                              />
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="29"
                                height="28"
                                viewBox="0 0 29 28"
                                fill="none"
                              >
                                <path
                                  d="M11 11.6667C12.2887 11.6667 13.3333 10.622 13.3333 9.33333C13.3333 8.04467 12.2887 7 11 7C9.71133 7 8.66666 8.04467 8.66666 9.33333C8.66666 10.622 9.71133 11.6667 11 11.6667Z"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M15.6667 2.3335H11C5.16668 2.3335 2.83334 4.66683 2.83334 10.5002V17.5002C2.83334 23.3335 5.16668 25.6668 11 25.6668H18C23.8333 25.6668 26.1667 23.3335 26.1667 17.5002V11.6668"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M21.5 2.3335V9.3335L23.8333 7.00016"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M21.5 9.33333L19.1667 7"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M3.61499 22.1083L9.36666 18.2467C10.2883 17.6283 11.6183 17.6983 12.4467 18.41L12.8317 18.7483C13.7417 19.53 15.2117 19.53 16.1217 18.7483L20.975 14.5833C21.885 13.8017 23.355 13.8017 24.265 14.5833L26.1667 16.2167"
                                  stroke="black"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              <div>
                                <h2>Click to upload</h2>
                                {/* <p>or drag and drop</p> */}
                              </div>
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {galleryimages?.length > 0 && (
                  <div className="gallery-images">
                    <h3 style={{ paddingTop: "2rem", paddingBottom: "0px " }}>
                      Uploaded Gallery Images
                    </h3>
                    <div className="mainouteruploddiv_prnt">
                      <div
                        className="mainouteruploddiv"
                        style={{
                          paddingLeft: "15px",
                        }}
                      >
                        {galleryimages?.length > 0 &&
                          galleryimages.map((image, index) => (
                            <div
                              className="inerimgdiv"
                              style={{ position: "relative" }}
                              key={index}
                            >
                              <img
                                className="uplodeimg"
                                src={image}
                                alt={`uploaded-${index}`}
                                style={{
                                  width: "100px",
                                  height: "100px",
                                  objectFit: "cover",
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                }}
                              />
                              <button
                                onClick={() =>
                                  setGalleryImages(
                                    (prevImages) =>
                                      prevImages.filter((_, i) => i !== index) // Remove the image at this index
                                  )
                                }
                                style={{
                                  position: "absolute",
                                  top: "5px",
                                  right: "5px",
                                  backgroundColor: "rgba(255, 0, 0, 0.8)",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "18px",
                                  height: "18px",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.2)",
                                  fontSize: "12px",
                                  fontWeight: "bold",
                                  lineHeight: "1",
                                }}
                              >
                                &times; {/* HTML entity for a close icon */}
                              </button>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* Display remaining images in a separate div */}
              {/* <div className='mainouteruploddiv_prnt'> */}

              {/* <div
                className="mainouteruploddiv"
                style={{
                  display: "flex",
                  // flexWrap: "wrap",
                  gap: "10px",
                  marginTop: "20px",
                }}
              >
                {galleryimages?.length > 1 &&
                  galleryimages.slice(1).map((image, index) => (
                    <div className='inerimgdiv' key={index} style={{ position: "relative" }}>
                       <img
                       className='uplodeimg'
                        src={image}
                        alt={`uploaded-${index}`}
                        style={{
                          width: "100px",
                          height: "100px",
                          objectFit: "cover",
                          border: "1px solid #ccc",
                          borderRadius: "5px",
                        }}
                      />
                       <button
                        onClick={() =>
                          setGalleryImages((prevImages) => prevImages.filter((_, i) => i !== index + 1))
                        }
                        style={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          backgroundColor: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "50%",
                          width: "20px",
                          height: "20px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        X
                      </button>
                    </div>
                  ))}
              </div> */}

              <div className="productdiv">
                <p className="pt-0"> Name</p>
                <input
                  type="text"
                  placeholder=" Name"
                  className="appleinput"
                  value={inputs.title}
                  onChange={(e) =>
                    setInputs({ ...inputs, title: e.target.value })
                  }
                />
                <p>⁠Supply</p>
                <input
                  type="number"
                  min="0"
                  placeholder="⁠Supply"
                  className="appleinput"
                  value={inputs.supply}
                  onChange={(e) =>
                    setInputs({ ...inputs, supply: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                />
                <p>Max Buy amount for user</p>
                <input
                  type="number"
                  min="0"
                  placeholder="Max buy amount for user"
                  className="appleinput"
                  value={inputs.maxMintAmount}
                  onChange={(e) =>
                    setInputs({ ...inputs, maxMintAmount: e.target.value })
                  }
                  // onChange={(e) => {
                  //   const value = e.target.value;
                  //   if (value > inputs.supply) {
                  //     setInputs({ ...inputs, maxMintAmount: value });
                  //   } else {
                  //     toast.error("Cost per NFT must be less than Supply");
                  //   }
                  // }}
                  onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                />

                {inputs.maxMintAmount != null &&
                inputs.supply != null &&
                Number(inputs.maxMintAmount) > Number(inputs.supply) ? (
                  <p className="text-danger">
                    Mint amount user must be less than supply!
                  </p>
                ) : null}

                <p>Cost per NFT (BNB)</p>
                <input
                  type="number"
                  min="0"
                  placeholder="Cost per NFT"
                  className="appleinput"
                  value={inputs.cost}
                  onChange={(e) =>
                    setInputs({ ...inputs, cost: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                />
                <p>Property Price</p>
                <input
                  type="number"
                  min="0"
                  placeholder="Property Price"
                  className="appleinput"
                  value={inputs.propertyPrice}
                  onChange={(e) =>
                    setInputs({ ...inputs, propertyPrice: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                />
                {/* <p>Metadata</p>
              <input type='text' placeholder='Metadata' className='appleinput'
                value={inputs.metadata}
                onChange={(e) => setInputs({ ...inputs, metadata: e.target.value })}

              /> */}
                <p>⁠Location</p>
                <input
                  type="text"
                  placeholder="⁠Location"
                  className="appleinput"
                  value={inputs.location}
                  onChange={(e) =>
                    setInputs({ ...inputs, location: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                />
                <p>Area (m²)</p>
                <input
                  type="number"
                  min="0"
                  placeholder="Area"
                  className="appleinput"
                  value={inputs.area}
                  onChange={(e) =>
                    setInputs({ ...inputs, area: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                />
                <div className="two__inputs">
                  <div className="innner__inpuutss ">
                    <p>Bedrooms</p>
                    <input
                      type="number"
                      min="0"
                      placeholder="Bedrooms"
                      className="appleinput"
                      value={inputs.bedrooms}
                      onChange={(e) =>
                        setInputs({ ...inputs, bedrooms: e.target.value })
                      }
                      onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                    />
                  </div>
                  <div className="innner__inpuutss">
                    <p>Bathrooms</p>
                    <input
                      type="number"
                      min="0"
                      placeholder="Bathrooms"
                      className="appleinput"
                      value={inputs.bathrooms}
                      onChange={(e) =>
                        setInputs({ ...inputs, bathrooms: e.target.value })
                      }
                      onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                    />
                  </div>
                  {/* <div className='innner__inpuutss'>
                    <p>categoryIndex
                    </p>
                    <input type='number' placeholder='Bathrooms' className='appleinput'
                      value={inputs.categoryIndex
                      }
                      onChange={(e) => setInputs({
                        ...inputs, categoryIndex
                          : e.target.value
                      })}
                    />

                  </div> */}
                </div>
                <p>Annual Rental Income %</p>
                <input
                  type="number"
                  min="0"
                  placeholder="Annual Rental Income %"
                  className="appleinput"
                  value={inputs.annualRentalIncome}
                  onChange={(e) =>
                    setInputs({ ...inputs, annualRentalIncome: e.target.value })
                  }
                  onWheel={(e) => e.target.blur()} // Prevent number input scroll behavior
                />
                <p>Overview Text</p>
                {/* <textarea
                  class="form-control"
                  placeholder="Overview Text"
                  id="exampleFormControlTextarea1"
                  rows="3"
                  value={inputs.overviewText}
                  onChange={(e) =>
                    setInputs({ ...inputs, overviewText: e.target.value })
                  }
                ></textarea> */}

                <div className="w-100">
                  <ReactQuill
                    class="form-control"
                    rows="3"
                    value={text} // Replace with your state or props
                    onChange={(value) => setText(value)} // Replace with your handler
                  />
                </div>
                <p>General Info</p>
                {/* <textarea
                  class="form-control"
                  placeholder="General Info"
                  id="exampleFormControlTextarea1"
                  rows="3" 
                  value={inputs.generalInfo}
                  onChange={(e) =>
                    setInputs({ ...inputs, generalInfo: e.target.value })
                  }
                ></textarea> */}
                <div className="w-100">
                  <ReactQuill
                    class="form-control"
                    rows="3"
                    value={text1} // Replace with your state or props
                    onChange={(value) => setText1(value)} // Replace with your handler
                  />
                </div>
              </div>
              <div className="mainbuttonpro ">
                <button className="classbut" onClick={handleShow}>
                  Coming Soon Project
                </button>
                {/* <button className=" privew" type="submit" onClick={handleSubmit}> */}
                {/* <button className=" privew" type="submit" onClick={() => createMintCategory()}> */}
                <button
                  className=" privew"
                  type="submit"
                  onClick={() => createMintCategory()}
                >
                  Create Project
                </button>
              </div>
            </div>
          </div>
          <div className=" phonebutttton "></div>
        </section>
        <Modal
          className="ambmodalmain1"
          show={show}
          onHide={handleClose}
          centered
        >
          {/* <Modal.Header closeButton>
          <Modal.Title>
            Success
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M12.0008 13.9008L7.10078 18.8008C6.91745 18.9841 6.68411 19.0758 6.40078 19.0758C6.11745 19.0758 5.88411 18.9841 5.70078 18.8008C5.51745 18.6174 5.42578 18.3841 5.42578 18.1008C5.42578 17.8174 5.51745 17.5841 5.70078 17.4008L10.6008 12.5008L5.70078 7.60078C5.51745 7.41745 5.42578 7.18411 5.42578 6.90078C5.42578 6.61745 5.51745 6.38411 5.70078 6.20078C5.88411 6.01745 6.11745 5.92578 6.40078 5.92578C6.68411 5.92578 6.91745 6.01745 7.10078 6.20078L12.0008 11.1008L16.9008 6.20078C17.0841 6.01745 17.3174 5.92578 17.6008 5.92578C17.8841 5.92578 18.1174 6.01745 18.3008 6.20078C18.4841 6.38411 18.5758 6.61745 18.5758 6.90078C18.5758 7.18411 18.4841 7.41745 18.3008 7.60078L13.4008 12.5008L18.3008 17.4008C18.4841 17.5841 18.5758 17.8174 18.5758 18.1008C18.5758 18.3841 18.4841 18.6174 18.3008 18.8008C18.1174 18.9841 17.8841 19.0758 17.6008 19.0758C17.3174 19.0758 17.0841 18.9841 16.9008 18.8008L12.0008 13.9008Z"
                fill="white"
              />
            </svg>
          </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>
            <div className="modal2">
              {/* <img src='\product\tickkk.svg' className='tickkimg' alt='img' /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="213"
                height="213"
                viewBox="0 0 213 213"
                fill="none"
              >
                <path
                  d="M159.75 159.75C189.159 130.341 189.159 82.6591 159.75 53.2499C130.341 23.8407 82.6591 23.8407 53.2499 53.2499C23.8408 82.6591 23.8407 130.341 53.2499 159.75C82.6591 189.159 130.341 189.159 159.75 159.75Z"
                  fill="#3FC700"
                />
                <path
                  d="M193.678 83.5901C189.64 68.1832 181.534 54.0668 170.235 42.7674C153.212 25.7444 130.578 16.3698 106.504 16.3698C82.4294 16.3698 59.7956 25.7444 42.7727 42.7674C31.4744 54.0656 23.3686 68.1814 19.3306 83.5883L16.2642 82.785C20.4442 66.8343 28.8362 52.2218 40.5318 40.5265C58.1529 22.9045 81.5829 13.1997 106.504 13.1997C131.425 13.1997 154.855 22.9045 172.476 40.5265C184.172 52.2221 192.564 66.836 196.744 82.7868L193.678 83.5901Z"
                  fill="#3FC700"
                />
                <path
                  d="M200.903 81.5372C201.661 84.7393 199.678 87.9501 196.476 88.7071C193.273 89.4643 190.063 87.4814 189.306 84.2794C188.549 81.0773 190.531 77.8664 193.734 77.1095C196.936 76.3522 200.146 78.3348 200.903 81.5372Z"
                  fill="#3FC700"
                />
                <path
                  d="M12.1043 81.5372C11.3471 84.7393 13.33 87.9501 16.532 88.7071C19.7344 89.4643 22.945 87.4814 23.7022 84.2794C24.4591 81.0773 22.4766 77.8664 19.2745 77.1095C16.0718 76.3522 12.8613 78.3348 12.1043 81.5372Z"
                  fill="#3FC700"
                />
                <path
                  d="M106.504 199.797C81.5837 199.797 58.1536 190.092 40.5317 172.47C29.1014 161.04 20.8051 146.79 16.5388 131.258L19.595 130.418C23.7154 145.421 31.7311 159.187 42.7723 170.23C59.7961 187.252 82.4298 196.627 106.504 196.627C130.577 196.627 153.211 187.252 170.234 170.23C181.277 159.187 189.291 145.421 193.412 130.42L196.468 131.26C192.202 146.79 183.906 161.04 172.475 172.47C154.854 190.092 131.424 199.797 106.504 199.797Z"
                  fill="#3FC700"
                />
                <path
                  d="M12.3886 132.553C11.5964 129.359 13.5441 126.127 16.7376 125.335C19.9312 124.543 23.1635 126.491 23.9556 129.685C24.7478 132.878 22.8004 136.11 19.6066 136.903C16.4124 137.694 13.1804 135.747 12.3886 132.553Z"
                  fill="#3FC700"
                />
                <path
                  d="M200.619 132.553C201.411 129.359 199.464 126.127 196.27 125.335C193.076 124.543 189.844 126.491 189.052 129.685C188.26 132.878 190.207 136.11 193.401 136.903C196.595 137.694 199.827 135.747 200.619 132.553Z"
                  fill="#3FC700"
                />
                <path
                  d="M138.177 71.3188L92.7968 116.699L74.8306 98.7325L62.341 111.222L92.7968 141.678L150.667 83.8084L138.177 71.3188Z"
                  fill="white"
                />
              </svg>
              <h4 className="changespass">Congratulations</h4>
              <p className="approveddiv">
                Project has been successfully created.
              </p>
            </div>
            <div className="parentbuttons">
              <button
                className="okay"
                onClick={() => {
                  handleClose();
                }}
              >
                Done
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default Addnewproduct;
